export default __webpack_public_path__ + "static/media/theme3.cab59034.jpg";